import fetch from '../utils/fetch'

export function getTagList (query) {
  return fetch({
    url: '/baoxian/getTagList',
    method: 'get',
    params: query
  })
}
export function saveTag (params) {
  return fetch({
    url: '/baoxian/saveTag',
    method: 'post',
    data: params
  })
}
export function editTag (tagId, params) {
  return fetch({
    url: '/baoxian/editTag' + tagId,
    method: 'put',
    data: params
  })
}
export function delTag (tagId) {
  return fetch({
    url: '/baoxian/delTag/' + tagId,
    method: 'delete'

  })
}

export function getTaiKangOrderList (query) {
  return fetch({
    url: '/baoxian/getTaiKangOrderList',
    method: 'get',
    params: query
  })
}
export function getTaiKangOrderStatus (query) {
  return fetch({
    url: '/baoxian/getTaiKangOrderStatus',
    method: 'get',
    params: query
  })
}

export function exportInsuranceOrder (query) {
  return fetch({
    url: '/baoxian/exportInsuranceOrder',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/taikang.js